import React from 'react';
import { UI_THEME } from '../../config/constants';

interface ErrorMessageProps {
  message: string;
  onDismiss?: () => void;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, onDismiss }) => {
  return (
    <div style={{
      backgroundColor: UI_THEME.colors.background.error,
      border: `1px solid ${UI_THEME.colors.background.errorBorder}`,
      borderRadius: UI_THEME.borderRadius.sm,
      padding: `${UI_THEME.spacing.sm} ${UI_THEME.spacing.md}`,
      marginBottom: UI_THEME.spacing.lg
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: UI_THEME.spacing.sm,
        justifyContent: 'space-between'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: UI_THEME.spacing.sm }}>
          <svg width="20" height="20" fill={UI_THEME.colors.error} viewBox="0 0 20 20">
            <path 
              fillRule="evenodd" 
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" 
              clipRule="evenodd" 
            />
          </svg>
          <span style={{
            color: '#dc2626',
            fontSize: UI_THEME.fontSize.sm,
            fontWeight: UI_THEME.fontWeight.medium
          }}>
            {message}
          </span>
        </div>
        
        {onDismiss && (
          <button
            onClick={onDismiss}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              color: '#dc2626',
              padding: UI_THEME.spacing.xs,
            }}
            aria-label="Dismiss error"
          >
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 20 20">
              <path 
                fillRule="evenodd" 
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" 
                clipRule="evenodd" 
              />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};